import React, { useContext } from "react";
import styled from "styled-components";
import CarouselSlide from "./CarouselSlide";
import CarouselContext from "./CarouselContext";
export const CAROUSEL_CONTAINER_CLASS_NAME = "carousel-container";
const useCarouselRef = (carouselId) => {
  const carouselContext = useContext(CarouselContext);
  if (!carouselContext) {
    throw new Error("Carousel component needs to be used inside CarouselProvider.");
  }
  if (!carouselContext[carouselId]) {
    throw new Error(`CarouselContext does not contain anything for carousel id ${carouselId}`);
  }
  return carouselContext[carouselId].ref;
};
const StyledDiv = styled.div`
  &.carousel {
    overflow: hidden;

    .${CAROUSEL_CONTAINER_CLASS_NAME} {
      backface-visibility: hidden;
      display: flex;
      flex-direction: row;
      height: auto;
    }
  }
`;
const Carousel = ({ children, className = void 0, containerRef = void 0, carouselId }) => {
  const carouselRef = useCarouselRef(carouselId);
  return /* @__PURE__ */ React.createElement(StyledDiv, { className: `carousel ${className}`, ref: carouselRef }, /* @__PURE__ */ React.createElement("div", { className: CAROUSEL_CONTAINER_CLASS_NAME, ref: containerRef }, children));
};
Carousel.Slide = CarouselSlide;
export default Carousel;
